import { render } from "./PingGuTwoView.vue?vue&type=template&id=572c4cf5&scoped=true&ts=true"
import script from "./PingGuTwoView.vue?vue&type=script&lang=ts"
export * from "./PingGuTwoView.vue?vue&type=script&lang=ts"

import "./PingGuTwoView.vue?vue&type=style&index=0&id=572c4cf5&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572c4cf5"]])

export default __exports__